import * as Yup from 'yup';

const ImportExportValidation = Yup.object().shape({
  other_charges: Yup.number()
    .typeError('Amount must be a number') // Ensures it's a number
    .test('max-decimals', 'Amount must have at most 2 decimal places', (value) => {
      return /^\d+(\.\d{1,2})?$/.test(value); // Regular expression to check for max 2 decimal places
    }),
  incoterms: Yup.string().max(3, 'Incoterms must not be more than 3 characters'),
  authorization_number: Yup.string().max(300, 'Incoterms must not be more than 300 characters'),
});

export { ImportExportValidation };
